import { setActiveGroups } from "store/actions/optanonActions";
import { store } from "store/configureStore";

function OptanonWrapper() {
  window.dataLayer.push({ event: "OneTrustGroupsUpdated" });

  const activeGroups = window.OptanonActiveGroups.split(",")
    .filter((string) => string !== "")
    .map((string) => parseInt(string));

  console.log("Notifying consent update", activeGroups);
  store.dispatch(setActiveGroups(activeGroups));
}

window.OptanonWrapper = OptanonWrapper;
